module.exports = __webpack_public_path__ + "img/southafrica.76d58c71.svg";